import React from 'react';
import { getSiteConfig } from '../../utils/productUtils';

export const createBrandColumns = (onEdit) => {
  return [
    {
      accessorKey: 'name_ko',
      header: '브랜드명 (한글)',
      cell: ({ getValue, row }) => {
        const nameKo = getValue();
        const nameEn = row.original.name_en;
        return (
          <div>
            <div className="font-medium text-gray-900 truncate">
              {nameKo || '-'}
            </div>
            {nameEn && (
              <div className="text-xs text-gray-600 truncate">
                {nameEn}
              </div>
            )}
          </div>
        );
      },
      size: 120,
      minSize: 120,
      maxSize: 200,
    },
    {
      accessorKey: 'name_en',
      header: '브랜드명 (영문)',
      cell: ({ getValue }) => {
        const nameEn = getValue();
        return (
          <div className="truncate">
            {nameEn || '-'}
          </div>
        );
      },
      size: 120,
      minSize: 120,
      maxSize: 200,
    },
    {
      accessorKey: 'source_site',
      header: '출처 사이트',
      cell: ({ getValue }) => {
        const sourceSite = getValue();
        if (!sourceSite) return <span className="text-gray-400">-</span>;
        
        const siteConfig = getSiteConfig(sourceSite);
        return (
          <span className={siteConfig.className} style={siteConfig.style}>
            {siteConfig.name}
          </span>
        );
      },
      size: 100,
      minSize: 100,
      maxSize: 100,
    },
    {
      id: 'actions',
      header: '작업',
      cell: ({ row }) => (
        <div className="flex justify-center" onClick={(e) => e.stopPropagation()}>
          <button
            onClick={() => onEdit(row.original)}
            className="px-2 py-1 bg-slate-400 text-white rounded-md hover:bg-slate-700 transition-colors text-sm"
          >
            수정
          </button>
        </div>
      ),
      enableSorting: false,
      size: 40,
      minSize: 40,
      maxSize: 40,
    },
  ];
};

